import * as React from 'react';

import AmazonMusicIsologo from '@components/basics/streaming-isologos/amazon';
import AppleMusicIsologo from '@components/basics/streaming-isologos/apple';
import SpotifyIsologo from '@components/basics/streaming-isologos/spotify';
import TidalIsologo from '@components/basics/streaming-isologos/tidal';
import YouTubeMusic from '@components/basics/streaming-logos/youtube';
import SoundcloudIsologo from '@components/basics/streaming-isologos/soundcloud';
import FacebookIcon from '@components/basics/icons/social/facebook';
import TwitterIcon from '@components/basics/icons/social/twitter';
import InstagramIcon from '@components/basics/icons/social/instagram';
import SnapIcon from '@components/basics/icons/social/snap';
import TikTokIcon from '@components/basics/icons/social/tiktok';
import PandoraIsologo from '@components/basics/streaming-isologos/pandora';
import Deezer from '@components/basics/streaming-logos/deezer';
import GooglePlayIsologo from '@components/basics/streaming-isologos/google-play';
import JioSaavnIsologo from '@components/basics/streaming-isologos/jioSaavn';

export const StreamingLogoDecorator = (decoration: string) => {
  switch (decoration) {
    case 'Amazon Music':
      return <AmazonMusicIsologo />;
    case 'Apple Music':
      return <AppleMusicIsologo />;
    case 'Spotify':
      return <SpotifyIsologo />;
    case 'Soundcloud':
      return <SoundcloudIsologo />;
    case 'Pandora':
      return <PandoraIsologo />;
    case 'Deezer':
      return <Deezer />;
    case 'Google Play Music':
      return <GooglePlayIsologo />;
    case 'JioSaavn':
      return <JioSaavnIsologo />;
    case 'Tidal':
      return <TidalIsologo />;
    case 'YouTube':
      return <YouTubeMusic />;
    case 'Facebook':
      return <FacebookIcon />;
    case 'Twitter':
      return <TwitterIcon />;
    case 'Instagram':
    case 'IG Stories':
      return <InstagramIcon />;
    case 'Snapchat':
      return <SnapIcon />;
    case 'TikTok':
      return <TikTokIcon />;
    default:
      return undefined;
  }
};
